App.factory('validationHelper', ['$http', '$q', '$location', '$rootScope', '$route', function($http, $q, $location, $rootScope, $route) {
	var validationHelper = {};

	validationHelper.validateFormVerify = function($scope, ngForm) {
        return this.validatePin($scope, ngForm, false);
    };

    /**
     * Trigger our basic registration form validation helper.
     */
    validationHelper.validate = function($scope, bill_now) {
        // cookie date
		var date = new Date();
		var minutes = 120;
		date.setTime(date.getTime() + (minutes * 60 * 1000));

		// remove old cookies if they exist
		$.cookie("pop_domain", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_firstname", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_lastname", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_username", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_comm_pref", "",{ path: '/', expires: -5, domain: '.pop.co' });
        $.cookie("pop_comm_email", "",{ path: '/', expires: -5, domain: '.pop.co' });
        $.cookie("pop_comm_cell", "",{ path: '/', expires: -5, domain: '.pop.co' });
		
		//////////////////////////////////////////////////

		$.cookie("pop_domain", $scope.selectedDomain.Domain, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_firstname", $scope.formData.firstname, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_lastname", $scope.formData.lastname, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_username", $scope.formData.username, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_comm_pref",$scope.formData.comm_pref, { path: '/', expires: date, domain: '.pop.co' });

		/*-----------------*/

    	if (!$scope.showResendMessage) {
            return this.validateRegistration($scope, bill_now);
        } else {
            return this.resendVerification($scope);
        }
    }

    /**
     * Handles WHOIS contact validation.
     */
    validationHelper.validateWhois = function($scope) {
        var deferred = $q.defer(),
            fields = ['whois_name','whois_email','whois_address_line1','whois_address_line2',
                'whois_city','whois_state','whois_zip','whois_country','whois_phone',
                'whois_phone_countrycode','whois_phone_countrycode_numeric','privacy_enabled'],
            data = angular.copy($scope.formData),
            whoisData = {},
            field, i, j;

        // update whois data with subset of fields
        for (i in fields) {
            field = fields[i];
            for (j in data) {
                if (field == j && !whoisData[field]) {
                    whoisData[field] = data[j];
                }
            }
        }

        // add the domain
        whoisData.domain = $scope.selectedDomain.Domain;

        // trigger ajax
        $scope.ajax = true;

        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/validate/whois', whoisData)
            .success(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // track the funnel
                    POP.trackFunnel('signup/whois-validation-failed');

                    // handle rejection
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // track the funnel
                    POP.trackFunnel('signup/whois-validation-passed');

                    // resolve with response data
                    deferred.resolve(response);
                }
            })
            .error(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                // track the funnel
                POP.trackFunnel('signup/whois-validation-failed');

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred during validation.'
                });
            });

        // return the promise
        return deferred.promise;
    }

    /**
     * Handle validating a coupon code entered by a user.
     */
    validationHelper.validateCouponCode = function($rootScope) {
        var deferred = $q.defer(),
            code = angular.copy($scope.formData.promo_code),
            data = {
                'code': code,
                'total': $rootScope.calculateAmountDue()
            };

        void 0;

        // trigger ajax
        $scope.ajax = true;

        // handle the attempted registration with form data
        $http
            .put(POP.apiBaseUrl + '/billing/coupon/validate', whoisData)
            .success(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // handle rejection
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // resolve with response data
                    deferred.resolve(response);
                }
            })
            .error(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred while checking your coupon code.'
                });
            });

        // return the promise
        return deferred.promise;
    }

    /**
     * Given a specific set of validation errors coming from the API response, set the validity of the fields.
     */
    validationHelper.setFieldErrors = function(rules, $rootScope, formName) {
        // map rules to those accepted by angular
        var ruleMap = {
            'required': 'required',
            'min': 'minlength',
            'max': 'maxlength',
            'email': 'email',
            'match': 'pattern'
        };

        for (var field in rules) {
            for (var rule in rules[field]) {

                if (typeof ruleMap[rule] != 'undefined') {
                    rule = ruleMap[rule];
                } else {
                    // default to invalid which is a standard rule
                    void 0;
                    continue;
                }

                void 0;

                if ($rootScope[formName] != 'undefined' && $rootScope[formName][field] != 'undefined') {
                    $rootScope[formName][field].$setValidity(rule, false);
                } else {
                    void 0;
                }
            }
        }
    }

    /**
     * The over-arching handling for validating email and mobile forms. This is
     * the initiation of a registration in which a PIN is generated and sent
     * to the user via their preferred registration method.
     */
    validationHelper.validateRegistration = function($scope, bill_now) {
        var deferred = $q.defer(),
            data = angular.copy($scope.formData);

        void 0;

        // add cookie to data
        data.utmz_cookie = JSON.stringify($.cookie());

        // handle using the cookie coupon code if the user supplied no other coupon code
        if (!$scope.formData.coupon_code || !$scope.formData.coupon_code.length) {
            if (coupon_code && coupon_code.length) {
                $scope.formData.coupon_code = coupon_code;
                data.coupon_code = coupon_code;
            }
        }

        // check for other interesting data to send
        //data.coupon_code = $.cookie('coupon_code');
        //data.coupon_code = typeof data.coupon_code != 'undefined' ? data.coupon_code : null;
        data.tracking_code = $.cookie('tracking_code');
        data.tracking_code = typeof data.tracking_code != 'undefined' && data.tracking_code != 'undefined' ? data.tracking_code : null;
        data.domain = $scope.selectedDomain.Domain;
		
        // prepare our registration service bundle
		data.services = { domain: 'domain-' + $scope.selectedDomain.TLD };

        // default to atmail free plan
		if ($rootScope.modalServiceSignup !== true) {
			if ($scope.selectedEmail != null && $scope.selectedEmail == 'atmail') {
				data.services.atmail = 'atmail-free';
			}
		} else {
            void 0;

            // check for any additional plans to validate
            if ($scope.selectedPlan) {
                data.services[POP.currentService.data.service.slug] = $scope.selectedPlan.plan_info.slug;
            }

            // if the service isnt mail related, we should add by default
            if (POP.currentService.data.service.slug != 'atmail' && POP.currentService.data.service.slug != 'gapps') {
                data.services.atmail = 'atmail-free';
            }
        }

        // trigger ajax
        $scope.ajax = true;

        void 0;
        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/validate', data)
            .success(function(response) {
                // untrigger ajax
            	$scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // empty params
                    POP.params = {};

                    // user no longer needs to use resend since they failed
                    $scope.showResendMessage = false;

                    // track the funnel
                    POP.trackFunnel('signup/domain-registration-validation-failed');

                    // handle rejection
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // update POP params
                    POP.params = response.data;

                    // track the funnel
                    POP.trackFunnel('signup/domain-registration-validation-passed');

					// set the domain and signup token
					POP.logEvent('signup', 'verified', response.data.email);

                    // user must now use resend pin functionality
                    $scope.showResendMessage = true;

                    // set pertinent cookies if we're logging in
                    if (response.data.percolate) {
                        validationHelper.loadPercolator($scope, response.data);
                    }

                    // resolve with response data
                    deferred.resolve(response);
                }
            })
            .error(function(response) {
                // untrigger ajax
            	$scope.ajax = false;

                void 0;
                void 0;

                // track the funnel
                POP.trackFunnel('signup/domain-registration-validation-failed');

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred during validation.'
                });
            });

        // return the promise
        return deferred.promise;
    };

    /**
     * Handle resending verification. This assumes the user already made an
     * attempt and it didn't go through.
     */
    validationHelper.resendVerification = function($scope) {
        var deferred = $q.defer(),
            data = angular.copy($scope.formData);

        $scope.ajax = true;

        void 0;

        data = _.extend(data, {
            domain: $scope.selectedDomain.Domain,
            comm_pref: data.comm_pref,
            comm_email: data.comm_email,
            cell: data.cell,
            cell_countrycode: data.cell_countrycode,
            cell_countrycode_numeric: data.cell_countrycode_numeric,
			domain: $scope.selectedDomain.Domain
        });

        void 0;
        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/resend/', data)
            .success(function(response) {
                var key;

                $scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // track the funnel
                    POP.trackFunnel('signup/resend-pin-validation-failed');

                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // update POP params
                    POP.params.token = response.data.token;

                    // set token
                    $scope.formData.token = response.data.token;

                    // track the funnel
                    POP.trackFunnel('signup/resend-pin-validation-passed');

                    var date = new Date();
					var minutes = 120;
					date.setTime(date.getTime() + (minutes * 60 * 1000));
                    $.cookie("pop_registration_token",$scope.formData.token, {path: '/', expires:date, domain: '.pop.co'});

                    deferred.resolve(response);
                }
            })
            .error(function(response) {
            	$scope.ajax = false;

                void 0;
                void 0;

                // track the funnel
                POP.trackFunnel('signup/resend-pin-validation-failed');

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred.'
                });
            });

        // return the promise
        return deferred.promise;
    };

    /**
     * Special case to validate the PIN on form submission and not on clicking
     * nextStep like the rest of the fields.
     */
    validationHelper.validatePin = function($scope, isTest) {
        var deferred = $q.defer(),
			data = angular.copy($scope.formData),
            //bundle = $scope.currentBundle,
            field,
            key;

        void 0;
        void 0;
        void 0;
        void 0;
        void 0;

        $scope.ajax = true;

        // prepare data for registration
		data.domain = $scope.selectedDomain.Domain;
		data.services = { domain: 'domain-'+ $scope.selectedDomain.TLD };

        // ensure we have the mail plan
		if ($rootScope.modalServiceSignup !== true) {
			if ($scope.selectedEmail != null && $scope.selectedEmail == 'atmail') {
				data.services.atmail = 'atmail-free';
			}
		}

        $http
            .post(POP.apiBaseUrl + '/register/validate/pin', data)
            .success(function(response) {
            	$scope.ajax = false;

                void 0;
                void 0;

                if (response.code == 200) {
                    // track the funnel
                    POP.trackFunnel('signup/validate-pin-validation-passed');

                	/*
                    if (typeof _gaq != 'undefined') {
                        _gaq.push(['_trackPageview', 'activation-registration-initialized']);
                    }

                    if (typeof _kmq != 'undefined') {
    	                _kmq.push(['identify', $scope.selectedDomain.Domain]);
    	            }

    	            $('.step-5-verified').trigger('click');
                    */

                    // mark pin as validated
                    $scope.formData.pin_validated = $scope.formData.pin;

                    // set data as POP params
                    POP.params = response.data;

                    // set the domain and signup token
                    POP.logEvent('signup', 'verified', response.data.email);

                    //show success message, or at least a progress indicator
                    $scope.validPin = true;

                    // set pertinent cookies if we're logging in
                    if (response.data.percolate) {
                        validationHelper.loadPercolator($scope, response.data);
                    }

    			   	deferred.resolve(response);
                } else {
                    // track the funnel
                    POP.trackFunnel('signup/validate-pin-validation-failed');

                    // ensure next button is disabled
                    $scope.formData.pin_validated = false;

                    validationHelper.generateRejectResponse($scope, deferred, response);
                }
            }).error(function(response) {
            	$scope.ajax = false;

                void 0;
                void 0;

                // track the funnel
                POP.trackFunnel('signup/validate-pin-validation-failed');

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred.'
                });
            });

        return deferred.promise;
    };

    /**
     * Helper to handle the auto-login on registration completions.
     */
    validationHelper.loadPercolator = function($scope, data) {
        var amount = 0.00;

        void 0;

        // calculate the amount due
        if (typeof $scope.calculateAmountDue != 'undefined') {
            amount = $scope.calculateAmountDue();
            void 0;
        } else {
            void 0;
        }

        if (typeof $.cookie('pop_orig_url') === 'undefined') {
            $.cookie('pop_orig_url', POP.Util.u(), {path: '/', domain: '.pop.co'});
        }

        $.cookie('pop_domain', data.domain, { path: '/', domain: '.pop.co' });
        $.cookie('pop_domain_id', data.domain_id, { path: '/', domain: '.pop.co' });
		
        // TODO: update amount due
		// Trigger Facebook and Twitter Signup events if objects exist
		if (typeof _fbq !== "undefined" && typeof twttr !== "undefined") {
			window._fbq.push(['track', '6016727410301', { 'value': amount,'currency': 'USD' }]);
			twttr.conversion.trackPid('l4b31');	
		}

        // wtf sleep?
        setTimeout(function() {
            // track successful percolator event
            POP.trackFunnel('signup/percolate');

            // different handlers for service regs
			if ($rootScope.modalServiceSignup === true) {
                // if not logged in, assume we should log them in (fresh register)
                if (POP.currentUser) {
                    $location.url('/modal/percolator');
                    $rootScope.$apply();
                } else {
                    window.location = '/percolating';
                }

                //old service install handler
				//$location.url('/modal/percolator');
				//$rootScope.$apply();
			} else {
				window.location = '/percolating';
			}
        }, 3000);
    };

    /**
     * Handle logging in under certain circumstances.
     */
    validationHelper.login = function(data) {
        $.cookie('pop_domain', data.domain, { path: '/', domain: '.pop.co' });
        $.cookie('pop_domain_id', data.domain_id, { path: '/', domain: '.pop.co' });
        $.cookie('pop_weasel', data.token, { path: '/', domain: '.pop.co' });
    };

    /**
     * Given the scope, a deferred, and a response, handle generating a
     * response error message and flag any erroneous fields with their
     * accompanying validation errors.
     */
    validationHelper.generateRejectResponse = function($scope, deferred, response) {
        if (response.errors) {
			deferred.resolve(response);
        } else if (response.msg) {
            deferred.resolve({
                code: 500,
                msg: response.msg
            });
        } else {
            deferred.resolve({
                code: 500,
                msg: 'An unknown error has occurred on the backend. Please try again.'
            });
        }
    };

    return validationHelper;
}]);
